import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';
import {API_ROOT} from '../../../../../baseUrls';
import {GOOGLE_MAP_API_KEY} from '../../../../../config';
import {Button, TextField} from '@mui/material';
import withGoogleMaps from '../../../../organisms/with-google-maps/withGoogleMaps';
import Location from "../../../../util/common/Location";
import {connect} from 'react-redux';

class FileMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: '',
      enteredLatitude: props.location?.latitude || props.mindfile?.location?.latitude || 40.7484405,
      enteredLongitude: props.location?.longitude || props.mindfile?.location?.longitude || -73.9878584,
      location: props.location || props.mindfile?.location
    };
    if(!props.location && !!props.mindfile?.location){
      this.setLocation(props.mindfile.location)
    }
    this.map = null;
    this.maps = null;
    this.marker = null;
  }

  apiLoaded(map, maps) {
    this.map = map;
    this.maps = maps;
    const isDraggable = !!this.props.isDraggable;
    this.marker = new maps.Marker({
      position: { lat: this.state.enteredLatitude, lng: this.state.enteredLongitude },
      map: this.map,
      draggable: isDraggable,
    });
    this.marker.addListener('dragend', this.handleMarkerDragEnd.bind(this));
  }

  componentDidUpdate(prevProps, prevState) {
    const { enteredLatitude, enteredLongitude } = this.state;
    if (this.marker && (enteredLatitude !== prevState.enteredLatitude || enteredLongitude !== prevState.enteredLongitude)) {
      this.marker.setPosition({ lat: enteredLatitude, lng: enteredLongitude });
    }
    if (this.marker && this.props.isDraggable !== prevProps.isDraggable) {
      this.marker.setDraggable(!!this.props.isDraggable);
    }
  }

  setLocation(location){
    this.setState({location:location, enteredLatitude: location.latitude, enteredLongitude: location.longitude});
    if (this.map) {
      this.map.setCenter({lat: location.latitude, lng: location.longitude});
    }
    if (this.marker) {
      this.marker.setPosition({lat: location.latitude, lng: location.longitude});
    }
    this.props.updateLocation(location)
  }
  geolocate() {
    const addressEncoded = encodeURI(this.state.address);
    fetch(`${API_ROOT}/google-geocode?address=${addressEncoded}`, {
      credentials: 'include',
    })
    .then(resp => resp.json())
    .then(data => {
      if (data.status.toLowerCase() === 'ok') {
        const result = data.results.pop();
        const latitude = result.geometry.location.lat;
        const longitude = result.geometry.location.lng;

        let locality=null;
        let region=null;
        let country=null;
        for (const addressItem of result.address_components) {
          if (addressItem.types.includes('country')) {
            country = addressItem.long_name
          }
          if (addressItem.types.includes('administrative_area_level_1')) {
            region = addressItem.long_name
          }
          if (addressItem.types.includes('locality')) {
            locality = addressItem.long_name
          }
        }
        this.setLocation({latitude, longitude, locality, region, country})
      } else {
        // console.error('Geocoding API error: ', data)
      }
    })
    .catch((ignore) => {
      // console.error('Geocoding API error: ', e)
    });
  }

  recalculateLatLng(latitude, longitude) {
    this.setState({enteredLatitude: latitude, enteredLongitude: longitude})
    fetch(`${API_ROOT}/google-geocode?latlng=${latitude},${longitude}`, {
      credentials: 'include',
    })
    .then(resp => resp.json())
    .then(data => {
      if (data.status.toLowerCase() === 'ok') {
        let locality=null;
        let region=null;
        let country=null;
        for (const addressItem of data.results[0].address_components) {
          if (addressItem.types.includes('country')) {
            country = addressItem.long_name
          }
          if (addressItem.types.includes('administrative_area_level_1')) {
            region = addressItem.long_name
          }
          if (addressItem.types.includes('locality')) {
            locality = addressItem.long_name
          }
        }

        this.setLocation({latitude, longitude, locality, region, country})
      } else {
        console.error('Geocoding API error: ', data)
      }
    })
  }

  commitEnteredLatLng() {
    let latitude = +this.state.enteredLatitude
    if (this.state.enteredLatitude === '' || !isFinite(latitude)) {
      latitude = this.state.location?.latitude || 40.7484405
    }
    let longitude = +this.state.enteredLongitude
    if (this.state.enteredLongitude === '' || !isFinite(longitude)) {
      longitude = this.state.location?.longitude || -73.9878584
    }
    if (this.map) {
      this.map.setCenter({lat: latitude, lng: longitude});
    }
    if (this.marker) {
      this.marker.setPosition({lat: latitude, lng: longitude});
    }
    this.recalculateLatLng(latitude, longitude)
  }

  handleMarkerDragEnd(event) {
    this.recalculateLatLng(event.latLng.lat(), event.latLng.lng());
  }

  componentWillUnmount() {
    if (this.marker) {
      this.marker.setMap(null);
      this.marker = null;
    }
  }

  render() {
    const isDraggable = !!this.props.isDraggable
    const lat = this.state.enteredLatitude
    const lng = this.state.enteredLongitude

    return (
      <div id={this.props.id} style={{position: 'relative', display: 'flex', flexWrap:'wrap', gap: '0.5rem 1rem', width: "100%"}}>
        { isDraggable ?
          <div style={{
            display: 'flex',
            flexDirection:'column',
            gap: '0.5rem',
            flex: 1,
            minWidth: `min(${this.props.size === "large" ? "24" : "14" }rem, 100%)`,
            height: 'fit-content',
          }}>
            <div key="display" style={{display: 'flex', flexDirection:"column", gap: '0.5rem', flex:1}}>
              <div style={{fontSize:"12px", color:"rgba(0,0,0,0.54)"}}>Location</div>
              <Location id="locationDisplay" location={this.state.location} />
            </div>
            <div key="address" style={{display: 'flex', gap: '0.5rem', flex:1}}>
              <TextField
                size="small"
                variant="outlined"
                placeholder="Search by address"
                margin="none"
                value={this.state.address}
                onChange={e => {
                  this.setState({address: e.target.value});
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    this.geolocate();
                  }
                }}
                style={{width: "100%"}}
              />
              <Button variant="outlined" style={{color: 'rgba(0,0,0,0.87)', borderColor: 'rgba(0,0,0,0.23)'}} onClick={this.geolocate.bind(this)}>Find</Button>
            </div>
            <div key="latlng" style={{display: 'flex', gap: '0.5rem', flex:1}}>
              <TextField
                size="small"
                fullWidth
                margin="none"
                variant="outlined"
                label="Latitude"
                InputLabelProps={{style: {transform: 'translate(14px, -6px) scale(0.75)', overflow: 'visible'}}}
                value={this.state.enteredLatitude}
                onChange={e => this.setState({ enteredLatitude: e.target.value })}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    this.commitEnteredLatLng()
                  }
                }}
                onBlur={() => this.commitEnteredLatLng()}
              />
              <TextField
                size="small"
                fullWidth
                margin="none"
                variant="outlined"
                label="Longitude"
                InputLabelProps={{style: {transform: 'translate(14px, -6px) scale(0.75)', overflow: 'visible'}}}
                value={this.state.enteredLongitude}
                onChange={e => this.setState({ enteredLongitude: e.target.value })}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    this.commitEnteredLatLng()
                  }
                }}
                onBlur={() => this.commitEnteredLatLng()}
              />
            </div>
          </div>
          : null
        }
        <div id="googMap" style={{
          height: '400px',
          minHeight:'300px',
          position:'relative',
          flex:1,
          // minWidth:"calc(min(14rem, 100%))"
          minWidth: `min(${this.props.size === "large" ? "24" : "14" }rem, 100%)`,
        }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: GOOGLE_MAP_API_KEY }}
            yesIWantToUseGoogleMapApiInternals
            defaultZoom={10}
            center={{ lat, lng }}
            onGoogleApiLoaded={({ map, maps }) => this.apiLoaded(map, maps)}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    mindfile: state.mindfile,
  }
};

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(withGoogleMaps(FileMap));
